<div class="audit-query-item-user-rank-risk">
    <form-factory [formGroup]="form" 
                  [model]="userRankInput" 
                  (onBlur)="onUserRankBlur()"></form-factory>
</div>